import AttachmentList from "./AttachmentList";

export default function CustomerAttachments({ data }) {
  return (
    <div>
      <AttachmentList data={data} />
    </div>
  );
}
